import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ChecklistStore {
  isOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
  togglePanel: () => void;
  // ID du dernier chantier créé depuis la checklist (pour redirection devis/affectation/etc.)
  lastCreatedChantierId: string | null;
  setLastCreatedChantierId: (id: string | null) => void;
  // Flag pour savoir si on vient de créer un chantier depuis la checklist
  highlightNewChantier: boolean;
  setHighlightNewChantier: (value: boolean) => void;
}

export const useChecklistStore = create<ChecklistStore>()(
  persist(
    (set) => ({
      isOpen: false,
      openPanel: () => set({ isOpen: true }),
      closePanel: () => set({ isOpen: false }),
      togglePanel: () => set((state) => ({ isOpen: !state.isOpen })),
      lastCreatedChantierId: null,
      setLastCreatedChantierId: (id) => set({ lastCreatedChantierId: id }),
      highlightNewChantier: false,
      setHighlightNewChantier: (value) => set({ highlightNewChantier: value }),
    }),
    {
      name: 'b8ild-checklist-store',
      partialize: (state) => ({
        lastCreatedChantierId: state.lastCreatedChantierId,
        highlightNewChantier: state.highlightNewChantier,
      }),
    }
  )
);
